import { render, staticRenderFns } from "./OrthographForm.vue?vue&type=template&id=37f6c1f4&scoped=true&lang=pug&"
import script from "./OrthographForm.vue?vue&type=script&lang=js&"
export * from "./OrthographForm.vue?vue&type=script&lang=js&"
import style0 from "./OrthographForm.vue?vue&type=style&index=0&id=37f6c1f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f6c1f4",
  null
  
)

export default component.exports